import React from "react";
import { useJumboApp } from "@jumbo/hooks";
import { LAYOUT_NAMES } from "../../../layouts/layouts";

import InformacionLocal from "./InformacionLocal/InformacionLocal";

const LocalInformacion = () => {
  const { setActiveLayout } = useJumboApp();

  React.useEffect(() => {
    setActiveLayout(LAYOUT_NAMES.VERTICAL_DEFAULT);
  }, []);
  return (
    <div>
      <h2>Local - Información</h2>
      <InformacionLocal />
    </div>
  );
};

export default LocalInformacion;
